import { merge } from 'lodash';
import queueTranslations from 'queue/translations';
import uploaderTranslations from 'uploader/translations';
import cropTranslations from 'pages/crop/translations';
import cameraTabTranslations from 'tabs/Camera/translations';
import dropboxTabTranslations from 'tabs/Dropbox/translations';
import facebookTabTranslations from 'tabs/Facebook/translations';
import gdriveTabTranslations from 'tabs/GoogleDrive/translations';
import imageSearchTabTranslations from 'tabs/ImageSearch/translations';
import instagramTabTranslations from 'tabs/Instagram/translations';
import localTabTranslations from 'tabs/Local/translations';
import shutterstockTabTranslations from 'tabs/ShutterStock/translations';
import gettyTabTranslations from 'tabs/Getty/translations';
import iStockTabTranslations from 'tabs/iStock/translations';
import unsplashTabTranslations from 'tabs/Unsplash/translations';
import urlTabTranslations from 'tabs/URL/translations';
import metadataPageTranslations from 'pages/metadata/translations';

const rootTranslations = {
  en: {
    translation: {
      or: 'Or',
      back: 'Back',
      advanced: 'Advanced',
      close: 'Close',
      no_results: 'No results',
      search_placeholder: 'Search files',
      about_uw: 'About the Upload Widget',
      search: {
        placeholder: 'Search...',
        reset: 'Reset search',
      },

      menu: {
        files: 'My Files',
        web: 'Web Address',
        camera: 'Camera',
        gsearch: 'Image Search',
        gdrive: 'Google Drive',
        dropbox: 'Dropbox',
        facebook: 'Facebook',
        instagram: 'Instagram',
        shutterstock: 'Shutterstock',
        getty: 'gettyimages',
        istock: 'iStock',
        unsplash: 'Unsplash',
      },

      selection_counter: {
        selected: 'Selected',
      },

      actions: {
        upload: 'Upload',
        next: 'Next',
        clear_all: 'Clear all',
        log_out: 'Log out',
      },

      notifications: {
        general_error: 'An error has occurred.',
        general_prompt: 'Are you sure?',
        limit_reached: 'No more files can be selected.',
        invalid_add_url: 'The URL must be valid.',
        invalid_public_id: 'Public ID cannot contain \\,,&,#,%,<,>.',
        no_new_files: 'The files have already been uploaded.',
        image_purchased: 'Image Purchased',
        video_purchased: 'Video Purchased',
        purchase_failed: 'Purchase failed. Please try again.',
        service_logged_out: 'Service logged out due to error',
        great: 'Great',
        image_acquired: 'Image Acquired',
        video_acquired: 'Video Acquired',
        acquisition_failed: 'Acquisition failed. Please try again.',
      },

      advanced_options: {
        public_id_ph: 'Public ID',
        tags_ph: 'Add a tag',
        add_new: 'Add a new tag:',
        upload_preset_placeholder: 'Upload Preset',
        upload_preset_no_options: 'No upload preset',
      },

      landscape_overlay: {
        title: "Landscape mode isn't supported",
        description: 'Rotate your device back to portrait mode to continue.',
      },

      aria_label: {
        close: 'Close',
        back: 'Back',
      },
    },
  },
};

const translations = merge(
  rootTranslations,
  queueTranslations,
  uploaderTranslations,
  cropTranslations,
  cameraTabTranslations,
  dropboxTabTranslations,
  facebookTabTranslations,
  gdriveTabTranslations,
  imageSearchTabTranslations,
  instagramTabTranslations,
  localTabTranslations,
  shutterstockTabTranslations,
  gettyTabTranslations,
  iStockTabTranslations,
  unsplashTabTranslations,
  urlTabTranslations,
  metadataPageTranslations
);

export default translations;
